<script setup>
  import {ref, computed, onMounted, getCurrentInstance} from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import {usePageLoadingStore} from "../../../../../../stores/pageLoading";
  import { useNavigationStore } from '../../../../../../stores/navigation';
  import { storeToRefs } from 'pinia';
  import _ from "lodash";
  import moment from "moment/moment";
  import SNB from '../../../../../../layouts/nav/SNB.vue'
  import KSASecondaryButton from "@/components/ui-components/button/KSASecondaryButton.vue";
  import KSAPrimaryButton from "@/components/ui-components/button/KSAPrimaryButton.vue";
  import fileService from "@/services/fileService";
  import KSAInput from "@/components/ui-components/input/KSAInput.vue";
  import mypageUserService from "@/pages/user/services/mypage/mypageUserService";
  import mypageJobFairService from '../../../../services/mypage/jobFair/mypageJobFairService';

  const route = useRoute()
  const router = useRouter()
  const loadingStore = usePageLoadingStore()

  const { previousRoute } = storeToRefs(useNavigationStore());

  const globals = getCurrentInstance().appContext.config.globalProperties;
  const { $regex, $gb, $fileSize, alert, confirm } = globals;

  const residenceAreaRef = ref(null); // 사업장소재지
  const ciFileNameSize = ref(null); // 파일명 + 용량
  const bizFileNameSize = ref(null); // 파일명 + 용량
  const corpFileNameSize = ref(null); // 파일명 + 용량
  const createCorpFileNameSize = ref(null); // 파일명 + 용량
  const isCorpNameDisabled = computed(() => !!createCorp.value.bizNum);

  onMounted(()=>{
    loadingStore.loading = true;
    retrieveCorporation();
  })

  const createCorp = ref({
    "corpResumeAttaches": [
      {
        "attachSeq": 0,
        "fileName": "",
        "fileSize": "",
        "fileDir": "",
        "fileOrder": 0,
        "deleteYn": ""
      }
    ], // 회사이력서파일
    "chargeName": "", // 참가신청 담당자 이름
    "chargeDepart": "", // 참가신청 담당자 부서
    "chargeJob": "", // 참가신청 담당자 직위
    "chargeCompanyNum": "", // 참가신청 담당자 회사 직통번호
    "chargePhoneNum": "", // 참가신청 담당자 휴대전화
    "chargeEmail": "", // 참가신청 담당자 이메일
    "agreePrivacyYn": false,  // 약관동의유무
  })

  const inputError = ref({
    // 기업 기본 정보
    bizNum: "", // 사업자등록번호
    corpName: "", // 기업명
    ceoName: "", // 대표자명
    residenceArea: "", // 사업장소재지
    bizType: "", // 업종
    industryGb: "", // 산업군
    corpGb: "", // 기업형태
    foundYm: "", // 창립연월
    employeeNumGb: "", // 사원수
    salesAmtGb: "", // 매출액
    corpPublicYn: "", // 상장여부
    corpPublicGb: "", // 상장구분
    ciImg: "", // 로고이미지(CI)
    bizLicense: "", // 사업자등록증
    // 참가 신청 정보
    corpResumeAttaches: "", // 회사이력서파일
    // 참가 신청 담당자 정보
    chargeName: "", // 담당자 성명
    chargeDepart: "", // 담당자 부서
    chargeJob: "", // 담당자 직위
    chargeCompanyNum: "", // 담당자 회사 직통번호
    chargePhoneNum: "", // 담당자 휴대전화
    chargeEmail: "", // 담당자 이메일
    agreePrivacyYn: false, // 동의
  })

  // 상장여부 초기화
  const resetCorpPublic = (val) => {
    if (val === 'N') {
      createCorp.value.corpPublicGb = ''
      createCorp.value.corpPublicText = ''
    }
  }

  // 상장 기타 초기화
  const resetCorpPublicText = (val) => {
    if (val === '05') {
      createCorp.value.corpPublicText = ''
    }
  }

  // 이력서 양식 초기화
  const resetFile = (val) => {
    if (val === 'N') {
      createCorp.value.corpResumeAttaches[0].fileName = ''
      createCorp.value.corpResumeAttaches[0].fileDir = ''
      createCorp.value.corpResumeAttaches[0].fileSize = ''
      createCorpFileNameSize.value = ''
    }
  }

  // 산업군 기타 초기화
  const resetIndustryText = (val) => {
    inputError.value.industryGb = ''
    if (val === '06') {
      createCorp.value.industryText = ''
    }
  }

  // 기업형태 기타 초기화
  const resetCorpText = (val) => {
    inputError.value.corpGb = ''
    if (val === '05') {
      createCorp.value.corpText = ''
    }
  }

  // 기업 상세 정보 조회 
  const retrieveCorporation = () => {
    mypageJobFairService.retrieveCorporation(route.query.corpId)
      .then( async (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            // await nextTick();
            const result = res.data.result;
            // console.log('사용자', result);

            // 사업자등록번호
            if(result.bizNum ) {
              const bizNum = result.bizNum;
              if(bizNum) {
                result.bizNum = bizNum.substring(0,3) + '-' + bizNum.substring(3,5) + '-' + bizNum.substring(5);
              }
            }

            // 사업장소재지
            if(result.residenceArea1 && result.residenceArea2) {
              residenceAreaRef.value.initSelectedOption(result.residenceArea1, result.residenceArea2)
            }

            // 창립연월
            if(result.foundYm ) {
              const foundYm = result.foundYm;
              if(foundYm) {
                result.foundYm = foundYm.substring(0,4) + '.' + foundYm.substring(4,6);
              }
            }

            if(result.ciImgName){
              const originFileSize = $fileSize(result.ciImgSize);
              ciFileNameSize.value = result.ciImgName + '  ' + originFileSize;
            }

            if(result.bizLicenseName){
              const originFileSize = $fileSize(result.bizLicenseSize);
              bizFileNameSize.value = result.bizLicenseName + '  ' + originFileSize;
            }

            if(result.corpIntroName){
              const originFileSize = $fileSize(result.corpIntroSize);
              corpFileNameSize.value = result.corpIntroName + '  ' + originFileSize;
            }

            createCorp.value = result;
          }
        })
        .catch( (error) =>  {
          loadingStore.loading = false;
        });
  }

  // 기업 정보 등록
  const saveCorp = async () => {
    let isInvalid = false;
    // 기본 기본 정보
    // 사업자등록번호
    inputError.value.bizNum = '';

    const bizNum = createCorp.value.bizNum ? createCorp.value.bizNum.replace('-','').replace('-','') : createCorp.value.bizNum;
    if(!bizNum || bizNum.length !== 10) {
      inputError.value.bizNum = !bizNum ? '사업자등록번호를 입력하세요.' : '10자리 숫자를 입력하세요.';
      isInvalid = true;
    }

    // 대표자명, 사업장소재지, 업종
    const { corpName, ceoName, residenceArea1, residenceArea2, bizType } = createCorp.value;
    inputError.value.corpName = '';
    inputError.value.ceoName = '';
    inputError.value.residenceArea = '';
    inputError.value.bizType = '';

    // 기업명
    if(!corpName) {
      inputError.value.corpName = '기업명을 입력하세요.';
      isInvalid = true;
    }

    // 대표자명
    if(!ceoName) {
      inputError.value.ceoName = '대표자명을 입력하세요.';
      isInvalid = true;
    }

    //사업장소재지
    if((residenceArea1 === '' || residenceArea1 === '시/도 선택') ||
        (residenceArea2 === '' || residenceArea2 === '시/구/군 선택') ) {
      inputError.value.residenceArea = (residenceArea1 === '' || residenceArea1 === '시/도 선택') ? '시/도를 선택하세요.' : '시/구/군을 선택하세요.';
      isInvalid = true;
    }

    // 업종
    if(!bizType) {
      inputError.value.bizType = '업종을 입력하세요.';
      isInvalid = true;
    }

    // 산업구분, 기업형태, 창립연월, 사원수(인원구분), 매출액
    const { industryGb, corpGb, employeeNumGb, salesAmtGb } = createCorp.value;
    inputError.value.industryGb = '';
    inputError.value.corpGb = '';
    inputError.value.foundYm = '';
    inputError.value.employeeNumGb = '';
    inputError.value.salesAmtGb = '';


    // 산업군
    let industryText = createCorp.value.industryText;
    if(!industryGb) {
      inputError.value.industryGb = '산업군을 선택하세요.';
      isInvalid = true;
    } else if(industryGb === '06' && !industryText) {
      inputError.value.industryGb = '기타 산업군을 입력하세요.';
      isInvalid = true;
    } else if (industryGb !== '06') {
      industryText = '';
    }

    // 기업형태
    let corpText = createCorp.value.corpText;
    if(!corpGb) {
      inputError.value.corpGb = '기업형태를 선택하세요.';
      isInvalid = true;
    } else if(corpGb === '05' && !corpText) {
      inputError.value.corpGb = '기타 기업형태를 입력하세요.';
      isInvalid = true;
    } else if (corpGb !== '05') {
      corpText = '';
    }

    // 창립연월
    const foundYm = moment(createCorp.value.foundYm.replace('.', '')).format("YYYYMM")
    if(!foundYm) {
      inputError.value.foundYm = '창립연월을 입력하세요.';
      isInvalid = true;
    } else if (foundYm) {
      if(foundYm.length !== 6) {
        inputError.value.foundYm = '기간을 YYYY.MM 형식으로 입력하세요.';
        isInvalid = true;
      } else if(foundYm === 'Invalid date'  // 존재하지 않은 기간
          // || Number(nowYm) < Number(startYm)  // 미래 기간
      ) {
        inputError.value.foundYm = '올바른 기간을 입력하세요.';
        isInvalid = true;
      }
    }

    // 사원수(인원구분)
    if(!employeeNumGb || employeeNumGb === '00') {
      inputError.value.employeeNumGb = '사원수를 선택하세요.';
      isInvalid = true;
    }

    // 매출액
    if(!salesAmtGb || salesAmtGb === '00') {
      inputError.value.salesAmtGb = '매출액을 선택하세요.';
      isInvalid = true;
    }

    // 상장, 홈페이지 url
    const { corpPublicYn, corpPublicGb } = createCorp.value;
    inputError.value.corpPublicYn = '';
    inputError.value.corpPublicGb = '';

    // 상장
    let corpPublicText = createCorp.value.corpPublicText;
    if(!corpPublicYn) {
      inputError.value.corpPublicYn = '상장여부를 선택하세요.';
      isInvalid = true;
    } else if(corpPublicYn === 'Y' && !corpPublicGb) {
      inputError.value.corpPublicGb = '상장여부를 선택하세요.';
      isInvalid = true;
    } else if(corpPublicYn === 'Y' && corpPublicGb === '05' && !corpPublicText) {
      inputError.value.corpPublicGb = '기타 상장을 입력하세요.';
      isInvalid = true;
    } else if(corpPublicYn === 'Y' && corpPublicGb !== '05') {
      corpPublicText = '';
    }

    // 로고이미지(CI)
    const { ciImgName, ciImgSize, ciImgDir } = createCorp.value;
    inputError.value.ciImg = '';

    if(!ciImgName || !ciImgSize || !ciImgDir) {
      inputError.value.ciImg = '로고이미지 파일을 선택하세요.';
      isInvalid = true;
    }

    // 사업자등록증
    const { bizLicenseName, bizLicenseSize, bizLicenseDir } = createCorp.value;
    inputError.value.bizLicense = '';

    if(!bizLicenseName || !bizLicenseSize || !bizLicenseDir) {
      inputError.value.bizLicense = '사업자등록증 파일을 선택하세요.';
      isInvalid = true;
    }

    // 이력서 양식, 회사 이력서 양식 첨부, 모집인원
    const corpResumeAttaches =  _.filter(createCorp.value.corpResumeAttaches, attach => {
      return attach.fileName !== null && attach.fileName !== '';
    })
    inputError.value.corpResumeAttaches = '';

    // 참가 신청 담당자 정보
    const { chargeName, chargeDepart, chargeJob, chargeCompanyNum, chargePhoneNum } = createCorp.value;
    inputError.value.chargeName  = '';
    inputError.value.chargeDepart  = '';
    inputError.value.chargeJob  = '';
    inputError.value.chargeCompanyNum  = '';
    inputError.value.chargePhoneNum  = '';
    inputError.value.chargeEmail  = '';

    // 성명
    if(!chargeName) {
      inputError.value.chargeName = '성명을 입력하세요.';
      isInvalid = true;
    }

    // 부서
    if(!chargeDepart) {
      inputError.value.chargeDepart = '부서를 입력하세요.';
      isInvalid = true;
    }

    // 직위
    if(!chargeJob) {
      inputError.value.chargeJob = '직위를 입력하세요.';
      isInvalid = true;
    }

    // 회사 직통번호
    if(!chargeCompanyNum) {
      inputError.value.chargeCompanyNum = '회사 직통번호를 입력하세요.';
      isInvalid = true;
    }
    // 20250924(ella): 회사 직통번호 밸리데이션 제거
    // } else if(!$regex.generalPhoneNum.test(chargeCompanyNum)) {
    //
    //   inputError.value.chargeCompanyNum = '회사 직통번호를 숫자로만 입력하세요.';
    //   isInvalid = true;
    // }

    // 휴대전화
    if(!chargePhoneNum || chargePhoneNum.length !== 13) {
      inputError.value.chargePhoneNum = '휴대폰 번호를 입력하세요.';
      isInvalid = true;
    } else if(!$regex.phoneNum.test(chargePhoneNum)) {
      inputError.value.chargePhoneNum = '휴대폰 번호를 숫자로만 입력하세요.';
      isInvalid = true;
    }

    // 이메일 형식 확인
    const chargeEmail = createCorp.value.chargeEmail.trim()
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    // 이메일
    if(!chargeEmail) {
      inputError.value.chargeEmail = '이메일을 입력하세요.';
      isInvalid = true;
    } else if (!emailRegex.test(chargeEmail)) {
      inputError.value.chargeEmail = '유효한 이메일 형식을 입력하세요.';
      isInvalid = true;
    }

    // 약관 동의
    const agreePrivacyYn = createCorp.value.agreePrivacyYn ? 'Y' : 'N';
    inputError.value.agreePrivacyYn  = false;

    if(agreePrivacyYn === 'N') {
      // alert("필수 약관을 확인하고 동의해 주세요.");
      // isInvalid = true;
    }

    // 저장 처리
    if(!isInvalid) {
      let paramObj = {
        corpId: createCorp.value.corpId,
        bizNum: createCorp.value.bizNum ? createCorp.value.bizNum.replace('-','').replace('-','') : createCorp.value.bizNum,
        corpName: createCorp.value.corpName,
        ceoName: createCorp.value.ceoName,
        residenceArea1: createCorp.value.residenceArea1,
        residenceArea2: createCorp.value.residenceArea2,
        bizType: createCorp.value.bizType,
        industryGb: createCorp.value.industryGb,
        industryText: industryText,
        corpGb: createCorp.value.corpGb,
        corpText: corpText,
        foundYm: createCorp.value.foundYm ? createCorp.value.foundYm.replace('.','').replace('.','') : createCorp.value.foundYm,
        employeeNumGb: createCorp.value.employeeNumGb,
        salesAmtGb: createCorp.value.salesAmtGb,
        corpPublicYn: createCorp.value.corpPublicYn,
        corpPublicGb: createCorp.value.corpPublicGb,
        corpPublicText: corpPublicText,
        homeUrl: createCorp.value.homeUrl,
        ciImgName: createCorp.value.ciImgName,
        ciImgSize: createCorp.value.ciImgSize,
        ciImgDir: createCorp.value.ciImgDir,
        bizLicenseName: createCorp.value.bizLicenseName,
        bizLicenseSize: createCorp.value.bizLicenseSize,
        bizLicenseDir: createCorp.value.bizLicenseDir,
        corpIntro: createCorp.value.corpIntro,
        corpHistory: createCorp.value.corpHistory,
        corpIntroName: createCorp.value.corpIntroName,
        corpIntroSize: createCorp.value.corpIntroSize,
        corpIntroDir: createCorp.value.corpIntroDir,
        corpResumeAttaches,
        chargeName,
        chargeDepart,
        chargeJob,
        chargeCompanyNum,
        chargePhoneNum,
        chargeEmail,
        agreePrivacyYn,
      };
      // todo. 기업정보 수정 API 호출
      mypageJobFairService.updateJobFairCorp(paramObj)
        .then( async (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            alert(["기업정보 수정이 완료되었습니다."]);
            goBack();
          }
        })
        .catch( (res) =>  {
          alert([res.response.data.result.message]);
          loadingStore.loading = false;
        }); 
    } else {
      alert("필수 입력사항을 확인해 주세요.");
    }
  }

  const clickCancel = async () => {
    alert("기업정보 수정이 취소되었습니다.")
    goBack();
  }

  const goBack = () => {
    if(previousRoute.value) {
      router.push(previousRoute.value);
    } else {
      router.push({name: 'MyPageCorpJobFair', query: { tab: 'corp-info' }})
    }
  }

  // 특수문자 작성 안됨
  const filterText = (value) => {
    return value.replace(/[^a-zA-Z0-9ㄱ-ㅎ가-힣\s]/g, ''); // 특수문자 제거
  }

  const onInputChange = (event, key) => {
    const filteredValue = filterText(event.target.value).slice(0, 200); // 글자수 제한 200자

    // 필터링된 값 적용
    createCorp.value[key] = filteredValue;

    // 유효성 체크
    if (!filteredValue) {
      inputError.value[key] = '참가 목적을 입력하세요.';
    } else if (filteredValue.length > 200) {
      inputError.value[key] = '참가 목적은 최대 200자까지 입력하세요.';
    } else {
      inputError.value[key] = ''; // 유효성 통과시 에러 메시지 초기화
    }
  }

  // 사업자등록번호 검색 결과로 기업명 자동 세팅
  const onUpdateCorp = (corp) => {
    const hasCorp = !!corp && Number(corp.corpId) > 0 && !!corp.corpName && corp.corpName !== '검색 결과가 없습니다.';
    if (hasCorp) {
      createCorp.value.corpName = corp.corpName;
      inputError.value.corpName = '';
      return;
    }

    createCorp.value.corpName = '';
    inputError.value.corpName = '등록된 기업명이 없습니다.';
  }

  const validateText = (key) => {
    if (key === 'corpName') {
      if (createCorp.value.corpName.trim() === '') {
        inputError.value.corpName = '기업명을 입력하세요.';
      } else if (createCorp.value.corpName.length > 500) {
        inputError.value.corpName = '기업명은 최대 500자까지 입력하세요.';
      } else {
        inputError.value.corpName = '';
      }
    } else if (key === 'ceoName') {
      if (createCorp.value.ceoName.trim() === '') {
        inputError.value.ceoName = '대표자명을 입력하세요.';
      } else if (createCorp.value.ceoName.length > 50) {
        inputError.value.ceoName = '대표자명은 최대 50자까지 입력하세요.';
      } else {
        inputError.value.ceoName = '';
      }
    } else if (key === 'bizType') {
      if (createCorp.value.bizType.trim() === '') {
        inputError.value.bizType = '업종을 입력하세요.';
      } else if (createCorp.value.bizType.length > 50) {
        inputError.value.bizType = '업종은 최대 50자까지 입력하세요.';
      } else {
        inputError.value.bizType = '';
      }
    } else if (key === 'foundYm') {
      inputError.value.foundYm = '' ? '창립연월을 입력하세요.' : '';
    } else if (key === 'homeUrl') {
      if (createCorp.value.homeUrl.length > 100) {
        inputError.value.homeUrl = '홈페이지 URL은 최대 100자까지 입력하세요.';
      } else {
        inputError.value.homeUrl = '';
      }
    } else if (key === 'corpHistory') {
      // console.log(createCorp.value.corpHistory, '1111')
      // if (createCorp.value.corpHistory.length > 4000) {
      //   console.log(createCorp.value.corpHistory, '1111')
      //   inputError.value.corpHistory = '주요 연혁은 최대 4000자까지 입력하세요.';
      // } else {
      //   console.log(createCorp.value.corpHistory, '1111')
      //   inputError.value.corpHistory = '';
      // }
    } else if (key === 'chargeName') {
      if (createCorp.value.chargeName.trim() === '') {
        inputError.value.chargeName = '성명을 입력하세요.';
      } else if (createCorp.value.chargeName.length > 10) {
        inputError.value.chargeName = '성명은 최대 10자까지 입력하세요.';
      } else {
        inputError.value.chargeName = '';
      }
    } else if (key === 'chargeDepart') {
      if (createCorp.value.chargeDepart.trim() === '') {
        inputError.value.chargeDepart = '부서를 입력하세요.';
      } else if (createCorp.value.chargeDepart.length > 10) {
        inputError.value.chargeDepart = '부서는 최대 10자까지 입력하세요.';
      } else {
        inputError.value.chargeDepart = '';
      }
    } else if (key === 'chargeJob') {
      if (createCorp.value.chargeJob.trim() === '') {
        inputError.value.chargeJob = '직위를 입력하세요.';
      } else if (createCorp.value.chargeJob.length > 10) {
        inputError.value.chargeJob = '직위는 최대 10자까지 입력하세요.';
      } else {
        inputError.value.chargeJob = '';
      }
    } else if (key === 'chargeCompanyNum') {
      inputError.value.chargeCompanyNum = '' ? '회사 직통번호를 입력하세요.' : '';
    } else if (key === 'chargePhoneNum') {
      inputError.value.chargePhoneNum = '' ? '휴대폰 번호를 입력하세요.' : '';
    } else if (key === 'chargeEmail') {
      const email = createCorp.value.chargeEmail.trim()
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

      if (email === '') {
        inputError.value.chargeEmail = '이메일을 입력하세요.'
      } else if (email.length > 50) {
        inputError.value.chargeEmail = '이메일은 최대 50자까지 입력하세요.'
      } else if (!emailRegex.test(email)) {
        inputError.value.chargeEmail = '유효한 이메일 형식을 입력하세요.'
      } else {
        inputError.value.chargeEmail = ''
      }
    }
  }

  const optionData = (key) => {
  }

  // 사업장소재지
  const onSelectedArea1Option = (option) => {
    createCorp.value.residenceArea1 = option;
    inputError.value.residenceArea = '';
  }

  const onSelectedArea2Option = (option) => {
    createCorp.value.residenceArea2 = option;
    inputError.value.residenceArea = '';
  }

  // 창립연월
  const rawInput = ref('')

  const formatDate = (event) => {
    inputError.value.foundYm = ''
    // 숫자만 필터링
    rawInput.value = event.target.value.replace(/\D/g, '').slice(0, 6)

    // YYYY.MM 형식으로 포맷팅
    if (rawInput.value.length >= 5) {
      createCorp.value.foundYm = `${rawInput.value.slice(0, 4)}.${rawInput.value.slice(4)}`
    } else {
      createCorp.value.foundYm = rawInput.value
    }
  }


  // 매출액
  const clickSalesAmtGb = (option) => {
    createCorp.value.salesAmtGb = option.value;
    inputError.value.salesAmtGb = '';
  }


  // 로고이미지(CI) 업로드
  const uploadFileCiImg = (createCorp) => {
    inputError.value.ciImg = ''
    const input = document.createElement('input');
    input.type= 'file';
    input.click();

    input.addEventListener('change', function(event){
      // console.log(event.target.files);
      const file = event.target.files[0];

      let paramObj = {
        container: 'public',
        folder: 'ciImg',
        file,
      }
      fileService.uploadFile(paramObj)
          .then((res) => {
            // console.log(res);
            if(res.data.code.toLowerCase() === 'success') {
              const result = res.data.result;
              // console.log(result);
              createCorp.ciImgName = result.originalFilename;
              createCorp.ciImgSize = result.fileSize;
              createCorp.ciImgDir = result.blobUrl;
              const upFileSize = $fileSize(result.fileSize);
              ciFileNameSize.value = result.originalFilename + '  ' + upFileSize;
            }
          }).catch( (error) =>  {
        console.log(error);
      });
    });
  }

  // 로고이미지(CI) 삭제
  const removeFileCiImg = (createCorp) => {
    console.log(createCorp)
    createCorp.ciImgName = '';
    createCorp.ciImgSize = '';
    createCorp.ciImgDir = '';
    inputError.value.ciImg = '';
    ciFileNameSize.value = '';
  }

  // 사업자등록증 업로드
  const uploadFileBizLicense = (createCorp) => {
    inputError.value.bizLicense = ''
    const input = document.createElement('input');
    input.type= 'file';
    input.click();

    input.addEventListener('change', function(event){
      // console.log(event.target.files);
      const file = event.target.files[0];

      let paramObj = {
        container: 'private',
        folder: 'bizLicense',
        file,
      }
      fileService.uploadFile(paramObj)
          .then((res) => {
            // console.log(res);
            if(res.data.code.toLowerCase() === 'success') {
              const result = res.data.result;
              // console.log(result);
              createCorp.bizLicenseName = result.originalFilename;
              createCorp.bizLicenseSize = result.fileSize;
              createCorp.bizLicenseDir = result.blobUrl;
              const upFileSize = $fileSize(result.fileSize);
              bizFileNameSize.value = result.originalFilename + '  ' + upFileSize;
            }
          }).catch( (error) =>  {
        console.log(error);
      });
    });
  }

  // 사업자등록증 삭제
  const removeFileBizLicense = (createCorp) => {
    createCorp.bizLicenseName = '';
    createCorp.bizLicenseSize = '';
    createCorp.bizLicenseDir = '';
    inputError.value.bizLicense = '';
    bizFileNameSize.value = '';
  }

  // 기업소개서 업로드
  const uploadFileCorpIntro = (createCorp) => {
    const input = document.createElement('input');
    input.type= 'file';
    input.click();

    input.addEventListener('change', function(event){
      // console.log(event.target.files);
      const file = event.target.files[0];

      let paramObj = {
        container: 'private',
        folder: 'corpIntro',
        file,
      }
      fileService.uploadFile(paramObj)
          .then((res) => {
            // console.log(res);
            if(res.data.code.toLowerCase() === 'success') {
              const result = res.data.result;
              // console.log(result);
              createCorp.corpIntroName = result.originalFilename;
              createCorp.corpIntroSize = result.fileSize;
              createCorp.corpIntroDir = result.blobUrl;
              const upFileSize = $fileSize(result.fileSize);
              corpFileNameSize.value = result.originalFilename + '  ' + upFileSize;
            }
          }).catch( (error) =>  {
        console.log(error);
      });
    });
  }

  // 기업소개서 삭제
  const removeFileCorpIntro = (createCorp) => {
    createCorp.corpIntroName = '';
    createCorp.corpIntroSize = '';
    createCorp.corpIntroDir = '';
    corpFileNameSize.value = '';
  }

  // 회사 이력서 양식 업로드
  const uploadFileCorpResume = () => {
    const input = document.createElement('input');
    input.type= 'file';
    input.click();

    input.addEventListener('change', function(event){
      // console.log(event.target.files);
      const file = event.target.files[0];

      let paramObj = {
        container: 'private',
        folder: 'corpResumeAttaches',
        file,
      }
      fileService.uploadFile(paramObj)
          .then((res) => {
            // console.log(res);
            if(res.data.code.toLowerCase() === 'success') {
              const result = res.data.result;
              // console.log(result);
              createCorp.value.corpResumeAttaches[0].fileName = result.originalFilename;
              createCorp.value.corpResumeAttaches[0].fileSize = result.fileSize;
              createCorp.value.corpResumeAttaches[0].fileDir = result.blobUrl;
              const upFileSize = $fileSize(result.fileSize);
              createCorpFileNameSize.value = result.originalFilename + '  ' + upFileSize;
            }
          }).catch( (error) =>  {
        console.log(error);
      });
    });
  }

  // 회사 이력서 양식 삭제
  const removeFileCorpResume = () => {
    createCorp.value.corpResumeAttaches[0].fileName = '';
    createCorp.value.corpResumeAttaches[0].fileSize = '';
    createCorp.value.corpResumeAttaches[0].fileDir = '';
    createCorpFileNameSize.value = '';
    inputError.value.corpResumeAttaches = '';
  }
</script>

<template>
  <div class="container">
    <div class="inner">
      <div class="flex-wrap">
        <SNB class="snb" />
        <!-- S : 강의 상세-->
        <div class="content">
          <div class="lecture-wrap">
            <div class="sub-title grid space-between">
              <h3>기업정보 수정</h3>
            </div>
            <p class="mt-xs">기업 정보는 수정과 동시에 &lt;기업소개&gt;페이지에 공개되므로 반드시 실제 정보를 입력하시기 바랍니다. (<span class="red">*</span>표시는 필수 입력사항입니다.)</p>
            <p class="mt-xs">수정된 기업정보는 [마이페이지 > 상시채용관 현황]에서 관리가 가능합니다.</p>
            <div class="lecture-detail">
              <!-- s : 기업 기본 정보 -->
              <div class="table-form mt-sm">
                <table class="vertical align-left">
                  <colgroup>
                    <col width="20%" />
                    <col />
                  </colgroup>
                  <tr>
                    <th colspan="2">기업 기본 정보</th>
                  </tr>
                  <tr>
                    <th class="mark">사업자등록번호</th>
                    <td>
                      <KSAInputCompNum class="text-box" v-model="createCorp.bizNum" @update:corp="onUpdateCorp" placeholder="10자리 숫자 입력" />
                      <div>
                        <small style="color:#E71414;">{{ inputError.bizNum }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">기업명</th>
                    <td>
                      <KSAInput class="text-box" @input="validateText('corpName')" maxLength="500" v-model="createCorp.corpName" :disabled="isCorpNameDisabled" />
                      <div>
                        <small style="color:#E71414;">{{ inputError.corpName }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">대표자명</th>
                    <td>
                      <KSAInput class="text-box" v-model="createCorp.ceoName" @input="validateText('ceoName')" maxLength="50" placeholder="대표명을 입력하세요." />
                      <div>
                        <small style="color:#E71414;">{{ inputError.ceoName }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">사업장소재지</th>
                    <td>
                      <KSASelectResidenceArea ref="residenceAreaRef" class="select" @selectOption1="onSelectedArea1Option" @selectOption2="onSelectedArea2Option"/>
                      <div>
                        <small style="color:#E71414;">{{ inputError.residenceArea }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">업종</th>
                    <td>
                      <KSAInput class="text-box" v-model="createCorp.bizType" @input="validateText('bizType')" maxLength="50" placeholder="업종을 입력하세요." />
                      <div>
                        <small style="color:#E71414;">{{ inputError.bizType }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">산업군</th>
                    <td>
                      <template v-for="option in $gb.INDUSTRY_GB">
                        <KSARadioButton class="check-box mr-md" name="industryGb" :label="option.label" v-model="createCorp.industryGb" :value="option.value" @change="resetIndustryText(option.value)" />
                        <div class="etc-box" v-if="option.label === '기타' && createCorp.industryGb == option.value" >
                          <KSAInput class="text-box" v-model="createCorp.industryText" maxLength="50" placeholder="기타 산업군을 입력하세요." />
                        </div>
                      </template>
                      <div>
                        <small style="color:#E71414;">{{ inputError.industryGb }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">기업형태</th>
                    <td>
                      <template v-for="option in $gb.CORP_GB">
                        <KSARadioButton class="check-box mr-sm" name="corpGb" :label="option.label" v-model="createCorp.corpGb" :value="option.value" @change="resetCorpText(option.value)"/>
                        <div class="etc-box" v-if="option.label === '기타' && createCorp.corpGb == option.value" >
                          <KSAInput class="text-box" v-model="createCorp.corpText" maxLength="50" placeholder="기타 기업형태를 입력하세요." />
                        </div>
                      </template>
                      <div>
                        <small style="color:#E71414;">{{ inputError.corpGb }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">창립연월</th>
                    <td>
                      <KSAInput class="text-box" @input="formatDate" v-model="createCorp.foundYm" placeholder="YYYY.MM" maxlength="7" />
                      <div>
                        <small style="color:#E71414;">{{ inputError.foundYm }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">사원수</th>
                    <td>
                      <KSASelect v-if="!createCorp.employeeNumGb" class="select" v-model="createCorp.employeeNumGb" :options="[{ label: '선택', value: '00' }, ...$gb['EMPLOYEE_NUM_GB']]" />
                      <KSASelect v-else class="select" v-model="createCorp.employeeNumGb" :options="$gb['EMPLOYEE_NUM_GB']" />
                      <div>
                        <small style="color:#E71414;">{{ inputError.employeeNumGb }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">매출액</th>
                    <td>
                      <KSASelect v-if="!createCorp.salesAmtGb" class="select" :options="[{ label: '선택', value: '' }, ...$gb['SALES_AMT_GB']]" @selectOption="clickSalesAmtGb"/>
                      <KSASelect v-else class="select" :options="$gb['SALES_AMT_GB']" @selectOption="clickSalesAmtGb"/>
                      <div>
                        <small style="color:#E71414;">{{ inputError.salesAmtGb }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark" rowspan="2">상장여부</th>
                    <td>
                      <KSARadioButton class="check-box mr-lg" label="상장" v-model="createCorp.corpPublicYn" value="Y" @change="resetCorpPublic('Y')" />
                      <KSARadioButton class="check-box mr-lg" label="비상장" v-model="createCorp.corpPublicYn" value="N" @change="resetCorpPublic('N')" />
                      <div>
                        <small style="color:#E71414;">{{ inputError.corpPublicYn }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td v-if="createCorp.corpPublicYn === 'Y'">
                      <template v-for="option in $gb.CORP_PUBLIC_GB">
                        <KSARadioButton class="check-box mr-sm" name="corpPublicGb" :label="option.label" v-model="createCorp.corpPublicGb" :value="option.value" @change="resetCorpPublicText(option.value)" />
                        <div class="etc-box" v-if="option.label === '기타' && createCorp.corpPublicGb == option.value" >
                          <KSAInput class="text-box" v-model="createCorp.corpPublicText" maxLength="50" placeholder="기타 상장을 입력하세요." />
                        </div>
                      </template>
                      <div>
                        <small style="color:#E71414;">{{ inputError.corpPublicGb }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>홈페이지 URL</th>
                    <td>
                      <KSAInput class="text-box" v-model="createCorp.homeUrl" @input="validateText('homeUrl')" maxLength="100" placeholder="홈페이지 URL을 입력하세요." />
                      <div>
                        <small style="color:#E71414;">{{ inputError.homeUrl }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">로고이미지(CI)</th>
                    <td class="text-box">
                      <div class="grid file">
                        <KSAPrimaryButton text="파일 선택" @click="uploadFileCiImg(createCorp)" />
                        <KSAInput class="input icon" v-model="ciFileNameSize" @input="validateText('ciImg')" placeholder="파일 선택(가로 75px X 세로 40px 사이즈 이미지를 권장합니다.)" disabled />
                        <button class="delete" @click="removeFileCiImg(createCorp)"><i></i></button>
                      </div>
                      <small>최대 200MB 까지 첨부 가능</small>
                      <div>
                        <small style="color:#E71414;">{{ inputError.ciImg }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">사업자등록증</th>
                    <td class="text-box">
                      <div class="grid file">
                        <KSAPrimaryButton text="파일 선택" @click="uploadFileBizLicense(createCorp)" />
                        <KSAInput class="input icon" v-model="bizFileNameSize" placeholder="파일 선택" disabled />
                        <button class="delete" @click="removeFileBizLicense(createCorp)"><i></i></button>
                      </div>
                      <small>최대 200MB 까지 첨부 가능</small>
                      <div>
                        <small style="color:#E71414;">{{ inputError.bizLicense }}</small>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
              <!-- e : 기업 기본 정보 -->
              <!-- s : 기업 추가 정보 -->
              <div class="table-form mt-sm">
                <table class="vertical align-left">
                  <colgroup>
                    <col width="20%" />
                    <col />
                  </colgroup>
                  <tr>
                    <th colspan="2">기업 추가 정보</th>
                  </tr>
                  <tr>
                    <th>기업 소개</th>
                    <td>
                      <KSACKEditor ref="editorRef" v-if="createCorp.corpIntro !== undefined" v-model="createCorp.corpIntro" />
                    </td>
                  </tr>
                  <tr>
                    <th>주요 연혁</th>
                    <td>
                      <KSACKEditor ref="editorRef" v-if="createCorp.corpHistory !== undefined" v-model="createCorp.corpHistory" @update:modelValue="validateText('corpHistory')" />
                      <!-- <p>
                        <small style="color:#E71414;">{{ inputError.corpHistory }}</small>
                      </p> -->
                    </td>
                  </tr>
                  <tr>
                    <th>기업 소개서</th>
                    <td class="text-box">
                      <div class="grid file">
                        <KSAPrimaryButton text="파일 선택" @click="uploadFileCorpIntro(createCorp)" />
                        <KSAInput class="input icon" v-model="corpFileNameSize" placeholder="파일 선택" disabled />
                        <button class="delete" @click="removeFileCorpIntro(createCorp)"><i></i></button>
                      </div>
                      <small>최대 200MB 까지 첨부 가능</small>
                    </td>
                  </tr>
                </table>
              </div>
              <!-- e : 기업 추가 정보 -->
              <!-- s : 참가 신청 담당자 정보 -->
              <div class="table-form mt-sm">
                <table class="vertical align-left">
                  <colgroup>
                    <col width="20%" />
                    <col />
                  </colgroup>
                  <tr>
                    <th colspan="2">담당자 정보</th>
                  </tr>
                  <tr>
                    <th class="mark">성명</th>
                    <td>
                      <KSAInput class="text-box" v-model="createCorp.chargeName" @input="validateText('chargeName')" maxLength="10" placeholder="성명을 입력하세요." />
                      <p>
                        <small style="color:#E71414;">{{ inputError.chargeName }}</small>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">부서</th>
                    <td>
                      <KSAInput class="text-box" v-model="createCorp.chargeDepart" @input="validateText('chargeDepart')" maxLength="10" placeholder="부서를 입력하세요." />
                      <p>
                        <small style="color:#E71414;">{{ inputError.chargeDepart }}</small>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">직위</th>
                    <td>
                      <KSAInput class="text-box" v-model="createCorp.chargeJob" @input="validateText('chargeJob')" maxLength="10" placeholder="직위를 입력하세요." />
                      <p>
                        <small style="color:#E71414;">{{ inputError.chargeJob }}</small>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">회사 직통번호</th>
                    <td>
                      <!-- 20250924(ella): 회사 직통번호 밸리데이션 제거 -->
<!--                      <KSAInputGeneralPhoneNum class="text-box" label="" v-model="createCorp.chargeCompanyNum" @input="validateText('chargeCompanyNum')" placeholder="회사 직통번호를 입력하세요." />-->
                      <KSAInput class="text-box" v-model="createCorp.chargeCompanyNum" @input="validateText('chargeCompanyNum')" maxLength="50" placeholder="회사 직통번호를 입력하세요. ex) 02-1234-5678" />
                      <p>
                        <small style="color:#E71414;">{{ inputError.chargeCompanyNum }}</small>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">휴대전화</th>
                    <td>
                      <KSAInputPhoneNum class="input" v-model="createCorp.chargePhoneNum" label="" @input="validateText('chargePhoneNum')" maxLength="200" placeholder="휴대폰 번호를 입력하세요."/>
                      <p>
                        <small style="color:#E71414;">{{ inputError.chargePhoneNum }}</small>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">이메일</th>
                    <td>
                      <KSAInput class="text-box" v-model="createCorp.chargeEmail" @input="validateText('chargeEmail')" maxLength="50" placeholder="이메일 주소를 입력하세요." />
                      <p>
                        <small style="color:#E71414;">{{ inputError.chargeEmail }}</small>
                      </p>
                    </td>
                  </tr>
                </table>
              </div>
              <!-- e : 참가 신청 담당자 정보 -->
            </div>
            <div class="btn-wrap space-between">
              <KSASecondaryButton class="gray_button" text="취소" @click="clickCancel()" />
              <KSAPrimaryButton text="수정 완료" @click="saveCorp()" />
            </div>
          </div>
        </div>
        <!-- E : 강의 상세-->
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../../../../../assets/scss/theme";

.blue {
  color: $blue_color;
}

.etc-box {
  display: inline-block;
  width: 200px;
}

.table-form {
  table {
    &.vertical {
      &.align-left {
        th {
          text-align: left;
          small {
            display: block;
            font-size: $font-size_xs;
            color: $gray_color;
            font-weight: normal;
          }
        }
      }
    }
  }
  .clickable {
    text-decoration: underline;
    cursor: pointer;
  }
  .disabled {
    cursor: default;
    background: $gray-regular_color;
    border-color: $gray-regular_color;
    color: #fff;
  }
}

.terms-wrap {
  margin: 20px 0;

  > .check-box:first-child {
    @include font-size_md;
  }

  hr {
    border: $border_line;
    margin: 20px 0;
  }

  .terms-box {
    height: 180px;
    overflow-y: auto;
    @include font-size_xs;
    background: $gray-thin_color;
    border: $border_line;
    padding: 20px;
    margin: 10px 0 40px;
  }
}
</style>
